import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/BrandGeometry";
import { PROCESS } from "@/lib/content";

export default function HowWeWork() {
  return (
    <section id="how-we-work" className="border-b border-line bg-white" data-testid="how-we-work">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:px-10 sm:py-32 lg:px-16">
        <div className="max-w-3xl">
          <Reveal>
            <Eyebrow>How We Work</Eyebrow>
            <h2 className="mt-6 font-display text-4xl font-medium leading-tight tracking-tight text-navy sm:text-5xl">
              A concise, accountable process
            </h2>
            <p className="mt-6 text-base leading-relaxed text-slate-body sm:text-lg">
              Four clear stages take a campaign from understanding a charity&rsquo;s objectives to
              structured monitoring of its outcomes.
            </p>
          </Reveal>
        </div>

        <div className="mt-14">
          {PROCESS.map((s, i) => (
            <Reveal key={s.no} delay={i * 0.05}>
              <div className="grid grid-cols-1 items-start gap-3 border-t border-line py-8 sm:grid-cols-12 sm:gap-8 sm:py-10">
                <div className="sm:col-span-3">
                  <span className="font-display text-5xl font-medium leading-none text-brand-green sm:text-6xl">
                    {s.no}
                  </span>
                </div>
                <h3 className="font-display text-2xl font-medium text-navy sm:col-span-3">
                  {s.title}
                </h3>
                <p className="text-base leading-relaxed text-slate-body sm:col-span-6 sm:text-lg">
                  {s.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
